module.exports = __webpack_public_path__ + "img/icon1.915c4c41.png";